import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/case-studies/${slug}`).then((r) => setC(r.data)); }, [slug]);

  if (!c) return <div className="pt-32 text-center">Loading…</div>;

  return (
    <div data-testid="case-detail" className="pt-24">
      <div className="relative h-[60vh] min-h-[400px]">
        <img src={c.cover} alt={c.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128]/95 via-[#0A1128]/40 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-8 lg:p-16 container mx-auto text-white">
          <Link to="/case-studies" className="text-sm text-white/70 hover:text-white">← All case studies</Link>
          <div className="text-[10px] font-mono uppercase tracking-widest text-[#00BFE0] mt-4 mb-3">{c.industry} · {c.client}</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter max-w-4xl">{c.title}</h1>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-8">
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-2">The Problem</div>
            <p className="text-lg leading-relaxed text-[#0A1128]">{c.problem}</p>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-2">Our Strategy</div>
            <p className="text-lg leading-relaxed text-[#0A1128]">{c.strategy}</p>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-2">Timeline</div>
            <p className="text-lg leading-relaxed text-[#0A1128]">{c.duration}</p>
          </div>
        </div>

        <aside className="bg-zinc-50 border border-zinc-200 rounded-2xl p-6 h-fit">
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">Results</div>
          <div className="space-y-4">
            {c.results.map((r) => (
              <div key={r.metric} className="border-b border-zinc-200 pb-3 last:border-0">
                <div className="font-display font-black text-3xl text-gradient">{r.value}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">{r.metric}</div>
              </div>
            ))}
          </div>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0A1128] text-white text-sm font-bold w-full justify-center">
            Get similar results <ArrowRight className="w-4 h-4" />
          </Link>
        </aside>
      </div>
    </div>
  );
}
